import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhTW from 'antd/lib/locale/zh_TW';
import enUS from 'antd/lib/locale/en_US';
import { useTranslation } from 'react-i18next';
import './utils/i18n';
import './App.css';

// 頁面組件
import Dashboard from './pages/Dashboard';
import StoreList from './pages/stores/StoreList';
import StoreDetail from './pages/stores/StoreDetail';
import StoreForm from './pages/stores/StoreForm';
import PurchaseOrderList from './pages/purchase-orders/PurchaseOrderList';
import PurchaseOrderDetail from './pages/purchase-orders/PurchaseOrderDetail';
import PurchaseOrderForm from './pages/purchase-orders/PurchaseOrderForm';
import ReviewTaskList from './pages/review-tasks/ReviewTaskList';
import ReviewTaskDetail from './pages/review-tasks/ReviewTaskDetail';
import ReviewTaskForm from './pages/review-tasks/ReviewTaskForm';
import Settings from './pages/Settings';
import NotFound from './pages/NotFound';

// 布局組件
import PageLayout from './components/PageLayout';

const App: React.FC = () => {
  const { i18n } = useTranslation();

  // 根據當前語言設置 Ant Design 的語言包
  const getAntdLocale = () => {
    return i18n.language === 'zh-TW' ? zhTW : enUS;
  };

  // 監聽語言變化，更新 document.title
  useEffect(() => {
    const { t } = i18n;
    document.title = t('app.title');
  }, [i18n]);

  return (
    <ConfigProvider locale={getAntdLocale()}>
      <Router>
        <PageLayout>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />

            <Route path="/stores" element={<StoreList />} />
            <Route path="/stores/new" element={<StoreForm />} />
            <Route path="/stores/:id" element={<StoreDetail />} />
            <Route path="/stores/:id/edit" element={<StoreForm />} />

            <Route path="/purchase-orders" element={<PurchaseOrderList />} />
            <Route path="/purchase-orders/new" element={<PurchaseOrderForm />} />
            <Route path="/purchase-orders/:id" element={<PurchaseOrderDetail />} />
            <Route path="/purchase-orders/:id/edit" element={<PurchaseOrderForm />} />

            <Route path="/review-tasks" element={<ReviewTaskList />} />
            <Route path="/review-tasks/new" element={<ReviewTaskForm />} />
            <Route path="/review-tasks/:id" element={<ReviewTaskDetail />} />
            <Route path="/review-tasks/:id/edit" element={<ReviewTaskForm />} />

            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </PageLayout>
      </Router>
    </ConfigProvider>
  );
};

export default App;
